 
import React, { ReactNode } from 'react';

import { Box } from '@constellation/core';

interface PropsType {
  children?: ReactNode;
}

export default function StyledBox({ children }: PropsType): React.JSX.Element {
  const styledBoxProps: any =
    (window as any).appConfig.BRAND_NAME === 'lloyds'
      ? { padding: 'none', bgColor: 'none', marginBottom: '08' }
      : {};
  return <Box {...styledBoxProps}>{children}</Box>;
}
